export const SERVICES = [
  {
    slug: "verifica-legale", icon: "ShieldCheck",
    it: {
      name: "Verifica legale (due diligence)",
      short: "Prima di firmare, controlliamo che chi vende abbia davvero diritto a vendere.",
      problem: "In Madagascar il rischio principale non è il prezzo: è comprare da chi non ha titolo, con confini incerti o contenziosi nascosti.",
      what: "Verifichiamo il titolo fondiario presso la Conservazione, l'identità e i diritti del venditore, i confini con un geometra e l'assenza di ipoteche o liti.",
      includes: ["Visura ipotecaria e stato del titolo", "Verifica identità e diritto del venditore", "Rilievo dei confini con geometra", "Rapporto scritto con semaforo dei rischi"],
      timing: "2–4 settimane indicative",
      price: "Su preventivo, in base a zona e complessità",
    },
    en: {
      name: "Legal due diligence",
      short: "Before signing, we check that the seller truly has the right to sell.",
      problem: "In Madagascar the main risk is not the price: it is buying from someone without title, with uncertain boundaries or hidden disputes.",
      what: "We verify the land title at the Land Registry, the seller's identity and rights, the boundaries with a surveyor, and the absence of mortgages or litigation.",
      includes: ["Mortgage certificate and title status", "Seller identity and rights check", "Boundary survey with a surveyor", "Written report with a risk traffic-light"],
      timing: "2–4 weeks, indicative",
      price: "Quoted per case, based on area and complexity",
    },
  },
  {
    slug: "costituzione-societa", icon: "Building2",
    it: {
      name: "Costituzione società",
      short: "La via più comune per uno straniero che vuole acquistare: una società malgascia fatta bene.",
      problem: "La legge malgascia limita l'acquisto diretto di terreni da parte di stranieri. Una società locale, se costituita correttamente, è la struttura più usata.",
      what: "Ti accompagniamo nella scelta della forma giuridica, nella costituzione, nelle autorizzazioni necessarie e nell'apertura del conto bancario.",
      includes: ["Scelta della forma giuridica con avvocato locale", "Costituzione e registrazione", "Richiesta autorizzazioni per l'acquisto", "Apertura conto bancario aziendale"],
      timing: "4–8 settimane indicative",
      price: "Su preventivo",
    },
    en: {
      name: "Company setup",
      short: "The most common route for a foreign buyer: a properly structured Malagasy company.",
      problem: "Malagasy law restricts direct land ownership by foreigners. A local company, if set up correctly, is the most used structure.",
      what: "We guide you through choosing the legal form, incorporation, the required authorisations and opening the bank account.",
      includes: ["Legal form choice with a local lawyer", "Incorporation and registration", "Purchase authorisation applications", "Business bank account opening"],
      timing: "4–8 weeks, indicative",
      price: "Quoted per case",
    },
  },
  {
    slug: "residenza", icon: "KeyRound",
    it: {
      name: "Residenza e visti",
      short: "Vivere in Madagascar: permessi per investitori, pensionati e lavoratori.",
      problem: "Le regole sui permessi cambiano e le informazioni online sono spesso obsolete o sbagliate.",
      what: "Ti aiutiamo a capire quale percorso si adatta alla tua situazione — investitore, pensionato o lavoratore — e prepariamo la pratica con professionisti locali, per te e la tua famiglia.",
      includes: ["Analisi del percorso adatto", "Raccolta e traduzione documenti", "Presentazione della pratica", "Aggiornamento sulle regole in vigore al momento della richiesta"],
      timing: "Variabile per tipologia",
      price: "Su preventivo",
    },
    en: {
      name: "Residency & visas",
      short: "Living in Madagascar: permits for investors, retirees and professionals.",
      problem: "Permit rules change and online information is often outdated or wrong.",
      what: "We help you understand which route fits your situation — investor, retiree or professional — and prepare the application with local professionals, for you and your family.",
      includes: ["Best-route analysis", "Document collection and translation", "Application filing", "Rules confirmed at the time of application"],
      timing: "Varies by permit type",
      price: "Quoted per case",
    },
  },
  {
    slug: "viaggio-sopralluogo", icon: "Plane",
    it: {
      name: "Viaggio di sopralluogo",
      short: "5–7 giorni sul campo: vedi i terreni, incontri il notaio, capisci la zona.",
      problem: "Comprare da una foto è il modo migliore per sbagliare. Ma organizzare da soli un viaggio esplorativo in Madagascar non è semplice.",
      what: "Organizziamo un programma di 5–7 giorni con accompagnatore italofono: visite ai terreni, incontro con notaio e geometra, immersione nella zona e nei suoi ritmi reali.",
      includes: ["Itinerario su misura in base ai tuoi obiettivi", "Accompagnatore italofono dedicato", "Incontri con notaio, geometra e professionisti locali", "Report finale con pro/contro di ogni visita"],
      timing: "Da programmare con 4–6 settimane di anticipo",
      price: "Su preventivo, in base a itinerario e periodo",
    },
    en: {
      name: "Scouting trip",
      short: "5–7 days on the ground: see the land, meet the notary, understand the area.",
      problem: "Buying from a photo is the best way to get it wrong. But organising an exploratory trip to Madagascar on your own is not easy.",
      what: "We organise a 5–7 day programme with an English/Italian-speaking guide: property visits, meetings with notary and surveyor, immersion in the area and its real rhythms.",
      includes: ["Tailored itinerary based on your goals", "Dedicated English/Italian-speaking guide", "Meetings with notary, surveyor and local professionals", "Final report with pros/cons of each visit"],
      timing: "Book 4–6 weeks ahead",
      price: "Quoted per itinerary and season",
    },
  },
  {
    slug: "gestione-costruzione", icon: "Hammer",
    it: {
      name: "Gestione e costruzione",
      short: "Dopo l'acquisto: progettiamo, costruiamo con imprese locali e gestiamo quando non ci sei.",
      problem: "Costruire a distanza senza referenti affidabili è la seconda causa di perdite, dopo i titoli incerti.",
      what: "Seguiamo progettazione e costruzione con imprese locali selezionate, con report fotografici periodici. E gestiamo l'immobile — manutenzione, affitti, personale — quando sei via.",
      includes: ["Progettazione con tecnici locali", "Direzione lavori con report periodici", "Selezione e gestione imprese", "Gestione immobile: manutenzione, affitti, personale"],
      timing: "Continuativo",
      price: "Su preventivo o canone di gestione",
    },
    en: {
      name: "Management & construction",
      short: "After the purchase: we design, build with local contractors and manage while you're away.",
      problem: "Building remotely without reliable contacts is the second biggest cause of losses, after uncertain titles.",
      what: "We oversee design and construction with selected local builders, with periodic photo reports. And we manage the property — maintenance, rentals, staff — while you're away.",
      includes: ["Design with local technicians", "Site supervision with periodic reports", "Contractor selection and management", "Property management: maintenance, rentals, staff"],
      timing: "Ongoing",
      price: "Quoted per case or management fee",
    },
  },
];
